import { render, staticRenderFns } from "./DashboardGuest.vue?vue&type=template&id=83f195ec&scoped=true"
import script from "./DashboardGuest.vue?vue&type=script&lang=js"
export * from "./DashboardGuest.vue?vue&type=script&lang=js"
import style0 from "./DashboardGuest.vue?vue&type=style&index=0&id=83f195ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f195ec",
  null
  
)

export default component.exports